export default "__VITE_PUBLIC_ASSET__d40fcb17__"